import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import config from "../../env/config";
import { useLang } from "../../Utility/hooks/useLang";

const LargeMenu = ({
  openCreditLifeModal,
  lang: propLang,
  isLocationOpen: propIsLocationOpen,
  setIsLocationOpen: propSetIsLocationOpen,
  locationDropdownRef: propLocationDropdownRef,
}) => {
  const CDN_URL = config.CDN_URL;
  const { lang: hookLang } = useLang();
  const lang = propLang || hookLang;

  const [internalIsLocationOpen, setInternalIsLocationOpen] = useState(false);
  const internalLocationDropdownRef = useRef(null);

  const isLocationOpen =
    propIsLocationOpen !== undefined
      ? propIsLocationOpen
      : internalIsLocationOpen;
  const setIsLocationOpen = propSetIsLocationOpen || setInternalIsLocationOpen;
  const locationDropdownRef =
    propLocationDropdownRef || internalLocationDropdownRef;

  useEffect(() => {
    if (propIsLocationOpen !== undefined) return;

    const handleLocationClickOutside = (event) => {
      if (
        locationDropdownRef.current &&
        !locationDropdownRef.current.contains(event.target)
      ) {
        setIsLocationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleLocationClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleLocationClickOutside);
    };
  }, [locationDropdownRef, setIsLocationOpen, propIsLocationOpen]);

  // const isArabic = lang === "ar";
  // const { t, i18n } = useTranslation();

  return (
    <div className="large-menu">
      {lang === "ar" ?
        <ul className="main-navigation" style={{ direction: 'rtl' }}>
          {/* PERSONAL INSURANCE */}
          <li className="menu-item has-dropdown">
            <Link
              to={
                (lang === "ar" ? "/ar" : "") +
                `/personal-lines-of-insurance`
              }
            >

              {lang === "ar" ? <span>التأمين الشخصي</span> :
                <span>PERSONAL INSURANCE</span>
              }
              <span className="arrow">
                <img src={`${CDN_URL}pasted-code.webp`} width={10} height={7}

                  alt="arrow"
                  aria-hidden="true"
                />
              </span>
            </Link>


            <div className="mega-dropdown personal-dropdown">
              <div className={lang === "ar" ? "dropdown-list Ar-spacing" : "dropdown-list"} >
                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/motor-insurance`
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}motor_insu_inc.webp`}
                      width={20} height={20}
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين المركبات
                    </span>
                    :
                    <span>Motor Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/travel-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}travel_inc.webp`}
                      width={20} height={20}
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين السفر
                    </span>
                    :
                    <span>Travel Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/housemaid-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img src={`${CDN_URL}domestic.webp`} width={20} height={20} />
                  </span>

                  {lang === "ar" ?
                    <span>
                      تأمين العمالة المنزلية
                    </span>
                    :
                    <span>Domestic Helper Insurance</span>
                  }
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/health-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}health_insu_inc.webp`}
                      width={20} height={20}
                    />
                  </span>

                  {lang === "ar" ?
                    <span>
                      التأمين الطبي
                    </span>
                    :
                    <span>Medical Insurance</span>}

                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/home-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}home_insu_inc.webp`}
                      width={20} height={20}
                    />
                  </span>

                  {lang === "ar" ?
                    <span>
                      تأمين المنزل
                    </span>
                    :
                    <span>Home Insurance</span>}

                </Link>



                <Link
                  // href="javascript:void(0)"
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   if (openCreditLifeModal) {
                  //     openCreditLifeModal(
                  //       "CreditLifeGeneralRequest",
                  //       "Credit Life Insurance"
                  //     );
                  //   }
                  // }}
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/credit-life-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}creditlife.webp`}
                      className="creditlife" width={23} height={23}
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      التأمين على الحياة الائتمانية
                    </span>
                    :
                    <span>Credit Life Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/yacht-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}boat.webp`} width={20} height={20}
                      className="creditlife"
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين القوارب
                    </span>
                    :
                    <span>Boat Insurance</span>}

                </Link>


              </div>

              <Link
                to={
                  (lang === "ar" ? "/ar" : "") +
                  "/personal-lines-of-insurance"
                } className="view-all"
              >


                {lang === "ar" ? <span>عرض جميع التأمينات الشخصية</span> : <span>View All Personal Insurance</span>}
                <span>→</span>
              </Link>


            </div>
          </li>

          {/* CORPORATE INSURANCE */}
          <li className="menu-item has-dropdown">
            <Link
              to={
                (lang === "ar" ? "/ar" : "") +
                `/corporate-insurance`
              }
            >


              {lang === "ar" ? <span> التأمينات للشركات</span> : <span>CORPORATE INSURANCE</span>}
              <span className="arrow">
                <img src={`${CDN_URL}pasted-code.webp`} width={10}
                  height={7} alt="arrow"
                  aria-hidden="true" />
              </span>
            </Link>


            <div className="mega-dropdown corporate-dropdown">
              <div className={lang === "ar" ? "dropdown-list Ar-spacing" : "dropdown-list"} >
                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/property-insurance`
                  }
                >

                  <span className="menu-icon">
                    <img src={`${CDN_URL}property.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين الممتلكات
                    </span>
                    :
                    <span>Property / Fire Insurance</span>}

                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/transit-insurance`
                  }
                >
                  <span className="menu-icon">
                    <img src={`${CDN_URL}transit.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين النقل
                    </span>
                    : <span>Transit Insurance</span>
                  }
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/project-insurance`
                  }
                >
                  <span className="menu-icon">
                    <img src={`${CDN_URL}project.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ?
                    <span>
                      التأمين الهندسي
                    </span>
                    :
                    <span>Project Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/motor-fleet-insurance`
                  }
                >

                  <span className="menu-icon">
                    <img src={`${CDN_URL}motor-fleet.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ? <span> تأمين أسطول المركبات</span> : <span>Motor Fleet Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/group-health-insurance`
                  }
                >

                  <span className="menu-icon">
                    <img src={`${CDN_URL}group-medical.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ? <span> التأمين الطبي الجماعي</span> : <span>Group Medical Insurance</span>}
                </Link>


              </div>
              <Link
                to={
                  (lang === "ar" ? "/ar" : "") +
                  `/corporate-insurance`
                } className="view-all"
              >

                {lang === "ar" ? <span>عرض جميع التأمينات للشركات</span> : <span>View All Corporate Insurance</span>}
                <span>→</span>
              </Link>


            </div>
          </li>

          {/* CLAIMS */}
          <li className="menu-item">
            <Link
              to={
                (lang === "ar" ? "/ar" : "") +
                `/claims-assistance`
              }
            >

              {lang === "ar" ? <span>المطالبات</span> : <span>CLAIMS</span>}
            </Link>

          </li>

          {/* MUSCAT LOCATION */}
          <li
            ref={locationDropdownRef}
            className={`menu-item has-dropdown location-menu ${isLocationOpen ? "is-open" : ""
              }`}
          >
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsLocationOpen((prev) => !prev);
              }}
            >
              <span className="location-icon">
                <img
                  // src={`${CDN_URL}ggIcon02.webp`} 
                  src={`${CDN_URL}ggIcon02.webp`}
                  alt="location"
                  aria-hidden="true" />
              </span>

              {lang === "ar" ? <span>مسقط .سلطنة عمان</span> : <span>MUSCAT, OMAN</span>}

              <span className="arrow"></span>
            </a>

            <div className="mega-dropdown location-dropdown">
              <div className="location-content">
                {lang === "ar" ? <h3>    نحن هنا في مسقط</h3> : <h3>We're here in Muscat</h3>}

                <div className="locationImg">
                  <img src={`${CDN_URL}oman_city.webp`} width={250} height={109} />
                </div>

                {lang === "ar" ? <h4>تأمبن.اوم</h4> : <h4>Tameen.om</h4>}
                {lang === "ar" ? <p>( مجموعة شركات أونك )</p> : <p>(ONEIC Group Company)</p>}

                {lang === "ar" ? <div className="nrTxt">اونك تأمين اس بي سي</div> : <div className="nrTxt">ONEIC Tameen SPC</div>}
                {lang === "ar" ? <div className="nrTxt">الخوير, مسقط</div> : <div className="nrTxt">Al Khuwair, Muscat, </div>}
                {lang === "ar" ? <div className="nrTxt">سلطنة عمان</div> : <div className="nrTxt">Sultanate of Oman.</div>}

                <div className="fsalicense">
                  <div className="licTxt">
                    <span className={lang === "ar" ? "licicon ArLicicon" : "licicon"}>
                      <img src={`${CDN_URL}license.webp`} width={22} height={26} />
                    </span>

                    <div className="licnum">

                      {lang === "ar" ? <div className="fstxt">هيئة الخدمات المالية</div> :
                        <div className="fstxt">FSA Licensed Insurance Broker</div>}

                      <div className="lsnum">(License No - L2669345)</div>
                    </div>
                  </div>

                  <a
                    className="Gtdirection"
                    href="https://www.google.com/maps/place/ONEIC,+3520+Wy,+Muscat/@23.594063,58.4195205,17z/data=!3m1!4b1!4m6!3m5!1s0x3e91ff098882735b:0xd53f2a4103cf3841!8m2!3d23.594063!4d58.4195205!16s%2Fg%2F1ptxy5y_3!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDgwNS4xIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className={lang === "ar" ? "directionIcon ArLicicon" : "directionIcon"}>
                      <img src={`${CDN_URL}ggIcon01.webp`} width={13} height={17} />
                    </span>


                    {lang === "ar" ? <span className="drtxt">
                      احصل على الاتجاهات <span className="arrTxt">›</span>
                    </span> :
                      <span className="drtxt">
                        Get Directions <span className="arrTxt">›</span>
                      </span>}


                  </a>
                </div>
              </div>
            </div>
          </li>

          {/* CONTACT US */}
        </ul>
        :
        <ul className="main-navigation">
          {/* PERSONAL INSURANCE */}
          <li className="menu-item has-dropdown">
            <Link
              to={
                (lang === "ar" ? "/ar" : "") +
                `/personal-lines-of-insurance`
              }
            >

              {lang === "ar" ? <span>التأمين الشخصي</span> :
                <span>PERSONAL INSURANCE</span>
              }
              <span className="arrow">
                <img src={`${CDN_URL}pasted-code.webp`} width={10}
                  height={7} alt="arrow"
                  aria-hidden="true" />
              </span>
            </Link>


            <div className="mega-dropdown personal-dropdown">
              <div className="dropdown-list">
                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/motor-insurance`
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}motor_insu_inc.webp`}
                      width={20} height={20}
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين المركبات
                    </span>
                    :
                    <span>Motor Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/travel-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}travel_inc.webp`}
                      width={20} height={20}
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين السفر
                    </span>
                    :
                    <span>Travel Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/housemaid-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img src={`${CDN_URL}domestic.webp`} width={20} height={20} />
                  </span>

                  {lang === "ar" ?
                    <span>
                      تأمين العمالة المنزلية
                    </span>
                    :
                    <span>Domestic Helper Insurance</span>
                  }
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/health-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}health_insu_inc.webp`}
                      width={20} height={20}
                    />
                  </span>

                  {lang === "ar" ?
                    <span>
                      التأمين الطبي
                    </span>
                    :
                    <span>Medical Insurance</span>}

                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/home-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}home_insu_inc.webp`}
                      width={20} height={20}
                    />
                  </span>

                  {lang === "ar" ?
                    <span>
                      تأمين المنزل
                    </span>
                    :
                    <span>Home Insurance</span>}

                </Link>



                <Link
                  // href="javascript:void(0)"
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   if (openCreditLifeModal) {
                  //     openCreditLifeModal(
                  //       "CreditLifeGeneralRequest",
                  //       "Credit Life Insurance"
                  //     );
                  //   }
                  // }}
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/credit-life-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}creditlife.webp`}
                      className="creditlife" width={23} height={23}
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      التأمين على الحياة الائتمانية
                    </span>
                    :
                    <span>Credit Life Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    "/yacht-insurance"
                  }
                >
                  <span className="menu-icon">
                    <img
                      src={`${CDN_URL}boat.webp`} width={20} height={20}
                      className="creditlife"
                    />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين القوارب
                    </span>
                    :
                    <span>Boat Insurance</span>}

                </Link>


              </div>

              <Link
                to={
                  (lang === "ar" ? "/ar" : "") +
                  "/personal-lines-of-insurance"
                } className="view-all"
              >


                {lang === "ar" ? <span>عرض جميع التأمينات الشخصية</span> : <span>View All Personal Insurance</span>}
                <span>→</span>
              </Link>


            </div>
          </li>

          {/* CORPORATE INSURANCE */}
          <li className="menu-item has-dropdown">
            <Link
              to={
                (lang === "ar" ? "/ar" : "") +
                `/corporate-insurance`
              }
            >


              {lang === "ar" ? <span> التأمينات للشركات</span> : <span>CORPORATE INSURANCE</span>}
              <span className="arrow">
                <img src={`${CDN_URL}pasted-code.webp`} width={10}
                  height={7} alt="arrow"
                  aria-hidden="true" />
              </span>
            </Link>


            <div className="mega-dropdown corporate-dropdown">
              <div className="dropdown-list">
                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/property-insurance`
                  }
                >

                  <span className="menu-icon">
                    <img src={`${CDN_URL}property.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين الممتلكات
                    </span>
                    :
                    <span>Property / Fire Insurance</span>}

                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/transit-insurance`
                  }
                >
                  <span className="menu-icon">
                    <img src={`${CDN_URL}transit.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ?
                    <span>
                      تأمين النقل
                    </span>
                    : <span>Transit Insurance</span>
                  }
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/project-insurance`
                  }
                >
                  <span className="menu-icon">
                    <img src={`${CDN_URL}project.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ?
                    <span>
                      التأمين الهندسي
                    </span>
                    :
                    <span>Project Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/motor-fleet-insurance`
                  }
                >

                  <span className="menu-icon">
                    <img src={`${CDN_URL}motor-fleet.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ? <span> تأمين أسطول المركبات</span> : <span>Motor Fleet Insurance</span>}
                </Link>

                <Link
                  to={
                    (lang === "ar" ? "/ar" : "") +
                    `/group-health-insurance`
                  }
                >

                  <span className="menu-icon">
                    <img src={`${CDN_URL}group-medical.webp`} width={20} height={20} />
                  </span>
                  {lang === "ar" ? <span> التأمين الطبي الجماعي</span> : <span>Group Medical Insurance</span>}
                </Link>


              </div>
              <Link
                to={
                  (lang === "ar" ? "/ar" : "") +
                  `/corporate-insurance`
                } className="view-all"
              >

                {lang === "ar" ? <span>عرض جميع التأمينات للشركات</span> : <span>View All Corporate Insurance</span>}
                <span>→</span>
              </Link>


            </div>
          </li>

          {/* CLAIMS */}
          <li className="menu-item">
            <Link
              to={
                (lang === "ar" ? "/ar" : "") +
                `/claims-assistance`
              }
            >

              {lang === "ar" ? <span>المطالبات</span> : <span>CLAIMS</span>}
            </Link>

          </li>

          {/* MUSCAT LOCATION */}
          <li
            ref={locationDropdownRef}
            className={`menu-item has-dropdown location-menu ${isLocationOpen ? "is-open" : ""
              }`}
          >
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsLocationOpen((prev) => !prev);
              }}
            >
              <span className="location-icon">
                <img
                  // src={`${CDN_URL}ggIcon02.webp`} 
                  src={`${CDN_URL}ggIcon02.webp`}
                  alt="location"
                  aria-hidden="true" />
              </span>

              {lang === "ar" ? <span>مسقط .سلطنة عمان</span> : <span>MUSCAT, OMAN</span>}

              <span className="arrow"></span>
            </a>

            <div className="mega-dropdown location-dropdown">
              <div className="location-content">
                {lang === "ar" ? <h3>    نحن هنا في مسقط</h3> : <h3>We're here in Muscat</h3>}

                <div className="locationImg">
                  <img src={`${CDN_URL}oman_city.webp`} width={250} height={109} />
                </div>

                {lang === "ar" ? <h4>تأمبن.اوم</h4> : <h4>Tameen.om</h4>}
                {lang === "ar" ? <p>( مجموعة شركات أونك )</p> : <p>(ONEIC Group Company)</p>}

                {lang === "ar" ? <div className="nrTxt">اونك تأمين اس بي سي</div> : <div className="nrTxt">ONEIC Tameen SPC</div>}
                {lang === "ar" ? <div className="nrTxt">الخوير, مسقط</div> : <div className="nrTxt">Al Khuwair, Muscat, </div>}
                {lang === "ar" ? <div className="nrTxt">سلطنة عمان</div> : <div className="nrTxt">Sultanate of Oman.</div>}

                <div className="fsalicense">
                  <div className="licTxt">
                    <span className={lang === "ar" ? "licicon ArLicicon" : "licicon"}>
                      <img src={`${CDN_URL}license.webp`} width={22} height={26} />
                    </span>

                    <div className="licnum">

                      {lang === "ar" ? <div className="fstxt">هيئة الخدمات المالية</div> :
                        <div className="fstxt">FSA Licensed Insurance Broker</div>}

                      <div className="lsnum">(License No - L2669345)</div>
                    </div>
                  </div>

                  <a
                    className="Gtdirection"
                    href="https://www.google.com/maps/place/ONEIC,+3520+Wy,+Muscat/@23.594063,58.4195205,17z/data=!3m1!4b1!4m6!3m5!1s0x3e91ff098882735b:0xd53f2a4103cf3841!8m2!3d23.594063!4d58.4195205!16s%2Fg%2F1ptxy5y_3!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDgwNS4xIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className={lang === "ar" ? "directionIcon ArLicicon" : "directionIcon"}>
                      <img src={`${CDN_URL}ggIcon01.webp`} width={13} height={17} />
                    </span>


                    {lang === "ar" ? <span className="drtxt">
                      احصل على الاتجاهات <span className="arrTxt">›</span>
                    </span> :
                      <span className="drtxt">
                        Get Directions <span className="arrTxt">›</span>
                      </span>}


                  </a>
                </div>
              </div>
            </div>
          </li>

          {/* CONTACT US */}
        </ul>
      }

    </div>
  );
};

export default LargeMenu;
